import { useAppSelector } from '@/app/store/hooks';
import type { Permission } from '@/entities/user/types';
import { selectCurrentUser } from '@/features/auth';

/**
 * Devuelve `true` si el usuario actual tiene TODOS los scopes requeridos.
 * Los usuarios `ADMIN` saltean cualquier check (mismo comportamiento que el backend).
 */
export function useHasScope(...required: readonly Permission[]): boolean {
  const user = useAppSelector(selectCurrentUser);
  if (!user) return false;
  if (user.role === 'ADMIN') return true;
  return required.every((p) => user.scopes.includes(p));
}

/**
 * Variante que admite "alguno de" estos scopes (OR semántico).
 */
export function useHasAnyScope(...allowed: readonly Permission[]): boolean {
  const user = useAppSelector(selectCurrentUser);
  if (!user) return false;
  if (user.role === 'ADMIN') return true;
  return allowed.some((p) => user.scopes.includes(p));
}
